import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Loader from "components/Loader";
import Item from "./Item";
import CMSFactory from "factories/CMS";
import CMSService from 'services/CMS';
import PubSub from 'services/PubSub';
import {actionsType, ecommerce} from 'config/constants';
import TagManagerService from 'services/TagManager'
import StorageService from 'services/StorageService';
import style from './style.scss'; //NOSONAR

import { useInView } from 'react-intersection-observer'

let animationTime = null;
let initialX = null;
let autoplayTime = null;
const time = 4000;
let actions = [];

let items = {}

const validSC = (item) => {
    const validation = item && item.sales_channel ? item.sales_channel : null;
    return CMSService.validSCItem(validation);
}
const validSeller = (item) => {
    if(!ecommerce.whiteLabel) return true;

    const validation = item && item.seller ? item.seller : null; 

    return CMSService.validSellerItem(validation);
}

const getActives = (elements, dateServer) => {
    if(!elements) return [];
    
    const dataUser = StorageService.getSecureItem('userData');
    const cencoPrime = dataUser && dataUser.CencoPrime_2020 ? dataUser.CencoPrime_2020 : '';
    const cencoPrimeCat = dataUser && dataUser.CencoPrime_CAT ? dataUser.CencoPrime_CAT : '';

    return elements.filter(item => {
        let startDate = item?.start_date ? CMSFactory.milliseconds(item.start_date) : '';
        let endDate = item?.end_date ? CMSFactory.milliseconds(item.end_date) : '';

        if (startDate && (startDate >= dateServer)) return false;
        if (endDate && (endDate <= dateServer)) return false;
        if (!item?.active) return false;
        if (!validSC(item)) return false;
        if (!validSeller(item)) return false;
        if (!item.image || !item.imagen_mobile) return false;
        if((item.audience_v2 === 'only_prime') && (!cencoPrime && !cencoPrimeCat)) return false
        if((item.audience_v2 === 'only_not_prime') && ((cencoPrime || cencoPrimeCat) || !dataUser)) return false

        return item;
    }).filter(Boolean);
};

const getInitialState = (banners, dateServer) => {
    return {
        images: getActives(banners, dateServer)
    };
}

let _isMounted = false;

const HeroSlider = (props) => {
    const banners = props.heroSlider;
    const { dateServer } = props;
    const initialState = getInitialState(banners, dateServer);
    const creative = props && props.creative  ? props.creative : null;
    const carousel = useRef(null);

    const [image, setImage] = useState(initialState.images || []);
    const [current, setCurrent] = useState(0);
    const [lastCurrent, setLastCurrent] = useState(-1);
    const [direction, setDirection] = useState('');
    const [animation, setAnimation] = useState(false);
    const [block, setBlock] = useState(false);
    const [isLoading, setIsLoading] = useState(!initialState.images);

    const [ref, inView] = useInView({
        threshold: 0,
    })

    useEffect(() => {
        _isMounted = true;
        getBanner();
        return function cleanup(){
            _isMounted = false;
        }
    }, [banners]);

    useEffect(() => {
        actions.push(PubSub.register(actionsType.SET_SALES_CHANNEL, () => {
            getBanner()
        }));

        actions.push(PubSub.register(actionsType.LOGGED_IN, () => {
            getBanner()
        }));

        return () => {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    useEffect(() => {
        if(inView && current) {
            sendViewedSlideToGtm(current, itemProps(image[current]))
        }
        if(props.autoplay !== false){
            playHero();
        }
        return function cleanup() {
            clearTimeout(autoplayTime);
        }
    }, [current]);

    useEffect(() => {
        if(!inView) {
            playHero({ play: false })
        } else {
            sendViewedSlideToGtm(current, itemProps(image[current]))
            playHero()
        }
    }, [inView])


    const sendViewedSlideToGtm = (i, gtmData) => {
        if(items[i]) return
        items = { ...items, [i]: true }
        TagManagerService.gtmHome(gtmData)
    }

    const itemProps = (_image) => {
        if (!_image) return false

        let id = ''

        if (typeof window !== 'undefined' && window.innerWidth <= 768) {
            id = _image.imagen_mobile ? _image.imagen_mobile.split('/').pop() : ''
        } else {
            id = _image.image ? _image.image.split('/').pop() : ''
        }

        return {
            id,
            name: _image.title,
            creative: 'Banner Principal',
            position: 'slot' + (parseInt(current) + 1),
            type: 'heroBanner',
        }
    }

    const getBanner = () => {
        if (_isMounted) {
            setImage([]);
            setImage(getActives(banners, dateServer));
            setIsLoading(false);
        }
    };

    const handleNext = () => {
        setItem(current+1,'next');
    };

    const handlePrev = () => {
        setItem(current-1,'prev');
    };

    const setItemPaginator = (pos) => {
        if (pos === current) return false;

        if(pos > current) {
            setItem(pos,'next');
        } else {
            setItem(pos, 'prev');
        }
    };

    const setItem = (pos, _direction) => {
        if(block) return false;

        const element = carousel.current;
        const slides = element && element.children;

        if(pos > (slides && slides.length - 1)) pos = 0;
        if(pos < 0) pos = (slides && slides.length - 1);

        setDirection(_direction);
        setLastCurrent(current);
        setCurrent(pos);

        setTimeout(animationTime);
        animationTime = setTimeout(() => {
            setAnimation(true);
            setBlock(true);

            animationTime = setTimeout(() => {
                setAnimation(false);
                setDirection('');
                setLastCurrent(-1);
                setBlock(false);
            }, 301);
        }, 20);
    };

    const startTouch = (e) => {
        initialX = e.touches[0].clientX;
    };

    let diffX = '';
    const moveTouch = (e) => {
        if (initialX === null) return false;

        const currentX = e.touches[0].clientX;
        diffX = initialX - currentX;
    };

    const playHero = (status) => {
        clearTimeout(autoplayTime);

        if (status && !status.play) return

        autoplayTime = setTimeout(() =>{
            handleNext();
        }, time);
    };

    const touchFinish = () => {
        if (diffX > 0) {
            handleNext();
        } else {
            handlePrev();
        }
    };

    const getImageSlide = () => {
        if(!image) return '';

        return image.map((img, i) => {
            const _props = {
                img,
                i,
                current,
                lastCurrent,
                creative,
            };

            return <Item {..._props} key={i + img.image} />
        })
    }

    return (
        <div className="new-home-hero-slider" ref={ref}>
            {image && image.length > 1 && (
                <button className="hero-slider-prev" onClick={handlePrev} aria-label="hero slider prev button" />
            )}
            {image && image.length > 1 && (
                <button className="hero-slider-next" onClick={handleNext} aria-label="hero slider next button" />
            )}
            {isLoading && <Loader />}
            {image && image.length === 1 && (
                <div className="new-home-banner">{getImageSlide()}</div>
            )}
            {image && image.length > 1 && (
                <div
                    className={'new-home-hero-slides  ' + direction + (animation ? ' animation ' : '')}
                    ref={carousel}
                    onTouchStart={startTouch}
                    onTouchMove={moveTouch}
                    onTouchEnd={touchFinish}
                >
                    {getImageSlide()}
                </div>
            )}
            {image && image.length > 1 && (
                <div className="hero-slider-navs">
                    {image.map((item, button) => {
                        return (
                            <button
                                className={'hero-slider-nav-number mobile-click' + (button === current ? ' active' : '')}
                                onClick={() => setItemPaginator(button)}
                                key={button}
                                aria-label={`hero slider nav ${button}`}
                            />
                        )
                    })}
                </div>
            )}
        </div>
    )
};

HeroSlider.propTypes = {
    heroSlider: PropTypes.array,
    creative: PropTypes.string,
    currentPage: PropTypes.number,
    autoplay: PropTypes.bool,
    dateServer: PropTypes.number
};

export default HeroSlider;
